// extracted by mini-css-extract-plugin
export default {"container":"status_container__rfOUk","icon":"status_icon__V2DqQ","typography":"status_typography__qmcRu"};